import { render, staticRenderFns } from "./ChooseCountry.vue?vue&type=template&id=5bf02f4c&"
import script from "./ChooseCountry.vue?vue&type=script&lang=js&"
export * from "./ChooseCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports